<template>
  <div class = "file-field-wrap">
    <Icon type="ios-attach" class="icon_trans" size="22" style = "margin-right:5px;" />
    <a :href = "url" class = 'file-field' download>{{name}}</a>
    <Icon @click = '_dele' v-if = 'dele' class = "my-icon" style = '' type="ios-close-circle" />
  </div>
</template>

<script>
// 附件字段渲染
export default {
  computed: {
    url(){
      return '/file/filemanage/downloadFileById/'+this.id
    }
  },
  props : {
    name: String,
    id: String,
    dele: Boolean
  },
  methods: {
    _dele(){
      this.$emit('on-delete',this.id)
    }
  }
}
</script>

<style scoped lang = "less">
.file-field-wrap{
  display: inline-block;
  padding:0 10px;
  background:white;
  margin-right:5px;
  .file-field{
    cursor: pointer;
    color: #666;
    &:hover{
      color: #04cbdb;
    }
  }
  .my-icon{
    margin-left:10px;
    cursor:pointer;
    font-size:14px
    ;display:none;
  }
  &:hover .my-icon{
    display:inline-block;
  }
}
.icon_trans {
  transform: rotate(45deg);
}
</style>